/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': '返回',
  'ai-floating-context-menu.ai-dynamic-surface.close': '關閉',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': '參考',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': '動作',
  'ai-smart-button.ai-actions.conversation-starters.loading.text': '正在載入對話啟動方式...',
  'ai-smart-button.ai-actions.conversation-starters.section.text': '詢問 Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': '提供意見反應',
  'ai-smart-button.ai-actions.help.section.text': '說明',
  'ai-smart-button.ai-actions.input.link-picker-button-label': '連結',
  'ai-smart-button.ai-actions.input.mention-button-label': '提及',
  'ai-smart-button.ai-actions.input.placeholder': '輸入您的需要',
  'ai-smart-button.ai-actions.input.send-button-label': '傳送',
  'ai-smart-button.ai-actions.item.betaLozenge': '測試版',
  'ai-smart-button.ai-actions.item.newLozenge': '新',
  'ai-smart-button.ai-actions.no-results-heading': '詢問 Rovo',
  'ai-smart-button.ai-actions.no-results-text': '向 Rovo 傳送您的提示以開始聊天。',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': '新增圖示',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': '客服人員圖示',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': '自動化圖示',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': '自動化',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': '瀏覽客服人員',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': '建立客服人員',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': '建立自動化',
  'ai-smart-button.ai-actions.rovo-agents.section.text': '工作室',
  'ai-smart-button.ai-actions.static-agent-fallback-1': '什麼是 Rovo 客服人員？',
  'ai-smart-button.ai-actions.static-agent-fallback-2': '如何在我的 Confluence 空間中使用 Rovo 客服人員？',
  'ai-smart-button.ai-actions.static-fallback-1': '什麼是 Rovo Chat？',
  'ai-smart-button.ai-actions.static-fallback-2': '協助我開始使用 Rovo Chat',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': '我可以如何提供協助？',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': '{name}，您好：',
  'ai-smart-button.ai-proactive-nudge.dismiss': '關閉',
  'ai-smart-button.feedback-action.ask-question-option': '提出問題',
  'ai-smart-button.feedback-action.can-contact-message':
    '是的，{product} 團隊可以與我聯繫，詢問我的使用體驗，以便改善 Atlassian 產品和服務。我同意 {privacyPolicy}',
  'ai-smart-button.feedback-action.can-contact-message-appify':
    '是的，{product} 團隊可以與我聯繫，詢問我的使用體驗，以便改善 Atlassian 應用程式和服務。我同意{privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': '取消',
  'ai-smart-button.feedback-action.choose-feedback-option': '選擇一個',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': '描述錯誤或問題',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': '讓我們知道您的想法',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': '您想要知道什麼？',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': '讓我們知道您希望改善的項目',
  'ai-smart-button.feedback-action.leave-comment-option': '寫下留言',
  'ai-smart-button.feedback-action.privacy-policy-link': '{product} 隱私政策。',
  'ai-smart-button.feedback-action.report-bug-option': '回報錯誤',
  'ai-smart-button.feedback-action.research-participation-message': '我想要參與產品研究',
  'ai-smart-button.feedback-action.select-feedback-heading': '選取意見反應',
  'ai-smart-button.feedback-action.submit-button-label': '傳送意見反應',
  'ai-smart-button.feedback-action.suggest-improvement-option': '建議改進',
  'ai-smart-button.feedback-action.title': '提供意見反應',
  'ai-smart-button.feedback-item.icon-label': '意見反應圖示',
  'ai-smart-button.reference.close-button-label': '關閉',
  'ai-smart-button.tooltip.label': '詢問 Rovo AI',
  'quick-summary.feedback.summary.placeholder': 'Atlassian Intelligence 有哪些方面表現良好？有什麼可以改善的嗎？',
  'quick-summary.feedback.title': '協助我們改善 Atlassian Intelligence',
};
